<template>
    <div class="newsletter-section section-space--ptb_120 default-bg" id="contact">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-10  ml-auto mr-auto">
                    <div class="section-title-wrapper text-center section-space--mb_50 wow move-up">
                        <h3 class="section-title text-white">Comienza desde ya a transformar la forma de investigar. <br> Ingresa tu email y te contactaremos</h3>
                    </div>
                    <!-- newsletter form -->
                    <div class="newsletter-form--one section-space--mb_20 text-center wow move-up">
                        <form action="#">
                            <input type="text" placeholder="Tu nombre">
                            <input type="email" placeholder="Email">
                            <button class="btn btn--white btn-text-theme">Contáctenme</button>
                        </form>
                    </div>
                    <!-- newsletter text -->
                    <h6 class="text-white text-center wow move-up">Cual es nuestra política de privacidad? <a href="#" class="hover-style-link hover-style-link--green">Lee más al respecto</a></h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'newsletter'
    }
</script>